<template>
  <v-card>
    <v-card-title>
      <v-row no-gutters>
        <v-col cols="3">
          <span class="table-card-title">Campanhas</span>
        </v-col>
        <v-col cols="6" class="d-flex justify-end align-center">
          <mf-status-filter v-if="itemsFilter[tab].length > 1" :items="itemsFilter[tab]" @input="getFilterResult" />
        </v-col>
        <v-col cols="3">
          <mf-search v-model="search" class="pt-0 mt-0" hide-details placeholder="Busca" />
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-0">
      <paginated-data-table
        :key="paginatedDataTableKey"
        ref="table"
        :headers="headers"
        :search="search"
        :query="query"
        :query-variables="queryVariables"
        :graphql-uri="$microservicesUrls['campaigns']"
        query-main-property-name="omni_campaigns"
        query-name="omniCampaigns"
      >
        <template #item="{ item }">
          <tr class="colorful-border" :style="{ borderLeft: `3px solid ${getStatusLabel(item.status).color}` }">
            <td>
              <mf-icon fill small :color="getStatusLabel(item.status).color"> fiber_manual_record </mf-icon>
              {{ getStatusLabel(item.status).text }}
            </td>
            <td class="nowrap-row">
              <v-tooltip v-model="showTooltipTitle[item._id]" max-width="250" top>
                <template #activator="{ on }">
                  <span v-on="on">
                    <router-link v-if="item.status !== 'FINISHED'" class="link" :to="{ name: 'Edit Mar.ia campaign', params: { id: item._id } }"
                      >{{ getFormatedText(item.title) }}
                    </router-link>
                    <router-link v-else class="link" :to="{ name: 'Mar.ia campaign results', params: { id: item._id } }">{{
                      getFormatedText(item.title)
                    }}</router-link>
                  </span>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
            </td>
            <td class="nowrap-row">
              <v-tooltip v-model="showTooltipDescription[item._id]" max-width="250" top>
                <template #activator="{ on }">
                  <span v-on="on">{{ getFormatedText(item.description) }}</span>
                </template>
                <span>{{ item.description | hifen }}</span>
              </v-tooltip>
            </td>
            <td>
              <div v-if="getChannelsEnabled(item.channels)">
                <v-chip v-for="channel in getChannelsEnabled(item.channels)" :key="channel" class="ma-1" small>
                  {{ channel }}
                </v-chip>
              </div>
              <span v-else>-</span>
            </td>
            <td>
              <mf-tooltip top max-width="300px" variant="secondary" :disabled="!showInactiveProductsWarning(item)">
                <template v-slot:activator="{ on }">
                  <div class="products-count">
                    <span :class="showInactiveProductsWarning(item) && 'warning-color'">
                      {{ item.products_count }}
                    </span>
                    <mf-icon v-if="showInactiveProductsWarning(item)" fill color="vermelho-0" size="20" class="mr-2">warning</mf-icon>
                  </div>
                </template>
                A quantidade de produtos ativos da campanha é menor que as variáveis de produto, o que está prejudicando o disparo de mensagens em um ou mais
                canais.
              </mf-tooltip>
            </td>
            <td class="nowrap-row">
              <v-tooltip v-if="item.units && item.units.length > 1" right>
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" style="cursor: auto" v-on="on">
                    {{ getUnits(item) }}
                  </span>
                </template>
                <span v-for="(unit, index) in item.units" :key="index" style="display: block">
                  {{ unit.name }}
                </span>
              </v-tooltip>
              <span v-else-if="item.units && item.units.length === 1">
                {{ item.units[0].name }}
              </span>
              <span v-else> - </span>
            </td>
            <td>{{ getPeriod(item.initial_date, item.final_date) }}</td>
            <td>
              {{ item.updated_at ? `${DateTime.fromISO(item.updated_at).toFormat('dd/MM/yyyy')}` : '-' }}
            </td>
            <td class="text-right">
              <v-menu :close-on-content-click="false">
                <template #activator="{ on }">
                  <mf-button color="cinza-0" icon="more_vert" type="icon" v-on:click.native="on.click" />
                </template>
                <v-list>
                  <v-list-item
                    v-if="item.status && ['FINISHED', 'ACTIVE'].includes(item.status)"
                    @click="$router.push({ name: 'Mar.ia campaign results', params: { id: item._id } })"
                  >
                    <v-list-item-title>Ver resultados</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.status && ['SCHEDULED', 'DRAFT', 'ACTIVE'].includes(item.status)"
                    @click="$router.push({ name: 'Edit Mar.ia campaign', params: { id: item._id } })"
                  >
                    <v-list-item-title>Editar</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.status && ['FINISHED', 'ACTIVE', 'DRAFT', 'SCHEDULED'].includes(item.status)"
                    @click="startCampaignsAction(item._id, 'CLONE', item.title)"
                  >
                    <v-list-item-title>Duplicar</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status && item.status === 'SCHEDULED'" @click="startCampaignsAction(item._id, 'SUSPEND', item.title)">
                    <v-list-item-title>Suspender</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status && item.status === 'ACTIVE'" @click="startCampaignsAction(item._id, 'FINALISE', item.title)">
                    <v-list-item-title>Finalizar</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.status || item.status === 'DRAFT'" @click="startCampaignsAction(item._id, 'DELETE', item.title)">
                    <v-list-item-title>Deletar</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.status && item.status === 'FINISHED'"
                    @click="$router.push({ name: 'View Mar.ia campaign', params: { id: item._id } })"
                  >
                    <v-list-item-title>Visualizar</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </paginated-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { truncate } from 'lodash'
import { DateTime } from 'luxon'
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { getPeriod, getStatusLabel, getUnits } from '@/config/helpers.js'
import {
  QUERY_LIST_OMNI_CAMPAIGNS,
  QUERY_DELETE_OMNI_CAMPAIGN,
  QUERY_UNSCHEDULE_OMNI_CAMPAIGN,
  QUERY_FINISH_OMNI_CAMPAIGN,
  QUERY_CLONE_OMNI_CAMPAIGN,
} from '@/modules/maria/campanha-da-maria/graphql'
import Swal from 'sweetalert2'

export default {
  name: 'CampaignIndexTable',
  components: {
    PaginatedDataTable,
  },
  filters: {
    hifen(value) {
      if (!value) return '-'
      return value
    },
  },
  props: {
    tab: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    search: '',
    showTooltipTitle: {},
    showTooltipDescription: {},
    DateTime: DateTime,
    campaignId: '',
    typeAction: '',
    paginatedDataTableKey: 0,
    toggleCampaignConfirmDialog: false,
    activeStatusToSearch: ['ACTIVE', 'SCHEDULED', 'DRAFT'],
    historyStatusToSearch: ['FINISHED'],
    itemsFilter: [
      [
        { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
        { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
      ],
      [{ label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true }],
    ],
  }),
  computed: {
    query() {
      return QUERY_LIST_OMNI_CAMPAIGNS
    },
    headers() {
      return [
        {
          text: 'Status',
          value: 'status',
          width: '12%',
        },
        {
          text: 'Campanha',
          value: 'title',
          width: '14%',
        },
        {
          text: 'Descrição',
          value: 'description',
          width: '14%',
        },
        {
          text: 'Canais',
          value: 'units.name',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Produtos',
          value: 'products_count',
          width: '10%',
        },
        {
          text: 'Lojas',
          value: 'units',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Data de validade',
          value: 'initial_date',
          width: '21%',
        },
        {
          text: 'Última atualização',
          value: 'updated_at',
          width: '8%',
        },
      ]
    },
    queryVariables() {
      return {
        status: this.tab ? this.historyStatusToSearch : this.activeStatusToSearch,
      }
    },
  },
  methods: {
    getPeriod,
    getStatusLabel,
    getUnits,
    getFilterResult(value) {
      if (this.tab) {
        this.historyStatusToSearch = value.length ? value : ['FINISHED']
      } else {
        this.activeStatusToSearch = value.length ? value : ['ACTIVE', 'SCHEDULED', 'DRAFT']
      }
    },
    showInactiveProductsWarning(item) {
      return !['DRAFT', 'FINISHED'].includes(item.status) && item.has_inactive_products
    },
    getFormatedText(text) {
      return truncate(text, {
        length: 24,
        separator: ' ',
      })
    },
    getChannelsEnabled(channels) {
      return channels ? Object.keys(channels).filter((channel) => channels[channel]?.active) : null
    },
    redirectToEdit(id) {
      this.$router.push({ name: 'Edit Mar.ia campaign', params: { id } })
    },
    startCampaignsAction(campaignId, typeAction, title) {
      switch (typeAction) {
        case 'DELETE':
          // chamar função responsável em cada caso
          this.deleteOmniCampaign(campaignId)
          break
        case 'FINALISE':
          this.finishOmniCampaign(campaignId)
          break
        case 'SUSPEND':
          this.unscheduleOmniCampaign(campaignId)
          break
        case 'CLONE':
          this.cloneOmniCampaign(campaignId, title)
          break
        default:
          console.error('Action type passed by argument is not valid.')
          break
      }
    },
    updateData() {
      this.paginatedDataTableKey += 1
    },
    deleteOmniCampaign(campaignId) {
      this.$confirm({
        title: 'Remover campanha',
        message: 'Tem certeza que deseja remover esta campanha?',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          await this.$apollo
            .mutate({
              mutation: QUERY_DELETE_OMNI_CAMPAIGN,
              context: {
                uri: this.$microservicesUrls['campaigns'],
              },
              variables: {
                id: campaignId,
              },
            })
            .then((response) => {
              Swal.fire({
                text: 'Campanha deletada com sucesso!',
                icon: 'success',
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  content: 'content-class',
                },
              })
              this.updateData()
            })
            .catch(() => {
              Swal.fire({
                text: 'Erro ao deletar campanha',
                icon: 'error',
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  content: 'content-class',
                },
              })
            })
        })
        .catch(() => {})
    },
    finishOmniCampaign(campaignId) {
      this.$confirm({
        title: 'Finalizar campanha',
        message: 'A campanha será movida para o status concluída.',
        confirmText: 'Finalizar',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          await this.$apollo
            .mutate({
              mutation: QUERY_FINISH_OMNI_CAMPAIGN,
              context: {
                uri: this.$microservicesUrls['campaigns'],
              },
              variables: {
                id: campaignId,
              },
            })
            .then((response) => {
              Swal.fire({
                text: 'Campanha finalizada',
                icon: 'success',
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  content: 'content-class',
                },
              })
              this.updateData()
            })
            .catch(() => {
              Swal.fire({
                text: 'Erro ao finalizar campanha',
                icon: 'error',
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  content: 'content-class',
                },
              })
            })
        })
        .catch(() => {})
    },
    unscheduleOmniCampaign(campaignId) {
      this.$confirm({
        title: 'Suspender campanha',
        message: 'A campanha será movida para o status rascunho.',
        confirmText: 'Suspender',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          await this.$apollo
            .mutate({
              mutation: QUERY_UNSCHEDULE_OMNI_CAMPAIGN,
              context: {
                uri: this.$microservicesUrls['campaigns'],
              },
              variables: {
                id: campaignId,
              },
            })
            .then((response) => {
              Swal.fire({
                text: 'Campanha suspensa',
                icon: 'success',
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  content: 'content-class',
                },
              })
              this.updateData()
            })
            .catch(() => {
              Swal.fire({
                text: 'Erro ao salvar campanha',
                icon: 'error',
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  content: 'content-class',
                },
              })
            })
        })
        .catch(() => {})
    },
    cloneOmniCampaign(campaignId, title) {
      this.$confirm({
        title: 'Duplicar campanha',
        message: `Deseja duplicar ${title ? 'a campanha ' + title.trim().bold() : 'esta campanha'}?`,
        confirmText: 'Duplicar',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          await this.$apollo
            .mutate({
              mutation: QUERY_CLONE_OMNI_CAMPAIGN,
              context: {
                uri: this.$microservicesUrls['campaigns'],
              },
              variables: {
                id: campaignId,
              },
            })
            .then((response) => {
              const id = response.data.cloneOmniCampaign._id
              this.redirectToEdit(id)
            })
            .catch(() => {
              Swal.fire({
                text: 'Erro ao duplicar campanha',
                icon: 'error',
                showConfirmButton: false,
                timer: 1000,
                customClass: {
                  content: 'content-class',
                },
              })
            })
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.products-count {
  display: flex;
  flex-direction: row;
  align-content: center;
  gap: 4px;
  span {
    line-height: 20px;
  }
  .warning-color {
    color: $vermelho-0;
  }
}

// caso venha a ter configuração de colunas nessa tabela, será necessário usar isso aqui:
// tr td:not(:first-child) .colorful-border {
//   border: none;
// }
</style>
